<script setup lang="ts">
  import LogoHtm from '@/shared/assets/icons/LogoHtm.svg';
  import { IconImage } from '@/shared/ui';

  defineProps<{
    title?: string;
  }>();
</script>

<template>
  <section
    id="logo"
    class="w-1/2 flex flex-col items-center justify-center"
  >
    <IconImage
      :src="LogoHtm"
      alt="Logo"
      class="pb-3"
    />
    <p class="text-gray-07 text-2xl/5">
      {{ title || 'Gestor de Documentos 2.0' }}
    </p>
  </section>
</template>

<style scoped>
  #logo {
    background: linear-gradient(
      90deg,
      rgba(246, 246, 246, 1),
      rgba(228, 231, 236, 1),
      rgba(223, 223, 223, 1)
    );
  }
</style>
